import { io } from 'socket.io-client';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.listeners = new Map();
  }

  connect(userId) {
    if (this.socket && this.isConnected) {
      console.log('WebSocket already connected, reusing connection');
      return;
    }

    try {
      const wsUrl = process.env.REACT_APP_WEBSOCKET_URL || 'http://localhost:50000';
      console.log('Connecting to WebSocket:', wsUrl, 'for user:', userId);
      
      this.socket = io(wsUrl, {
        transports: ['websocket', 'polling'],
        timeout: 20000,
        forceNew: true, // Force new connection
      });

      this.socket.on('connect', () => {
        console.log('WebSocket connected successfully');
        this.isConnected = true;
        console.log('Joining room for user:', userId);
        this.socket.emit('join', { user_id: userId });
      });

      this.socket.on('disconnect', (reason) => {
        console.log('WebSocket disconnected:', reason);
        this.isConnected = false;
      });

      this.socket.on('connect_error', (error) => {
        console.error('WebSocket connection error:', error);
        this.isConnected = false;
      });

      // Payment events
      this.socket.on('payment_initiated', (data) => {
        console.log('Payment initiated:', data);
        this.emit('payment_initiated', data);
      });

      this.socket.on('payment_completed', (data) => {
        console.log('Payment completed:', data);
        this.emit('payment_completed', data);
      });

    } catch (error) {
      console.error('Failed to initialize WebSocket:', error);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // Event listener management
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event);
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in ${event} callback:`, error);
        }
      });
    }
  }

  // Check if connected
  getConnectionStatus() {
    return this.isConnected;
  }
}

// Create singleton instance
const websocketService = new WebSocketService();

export default websocketService;
